(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/dropdown/assets/javascripts/dropdown.js') >= 0) return;  svs.modules.push('/components/ui/dropdown/assets/javascripts/dropdown.js');

'use strict';

svs.ui = svs.ui || {};
svs.ui.dropdown = svs.ui.dropdown || {};
svs.ui.Dropdown = class Dropdown {
  constructor(options) {
    this.log = svs.core.log.getLogger('ui:dropdown');

    const self = this;
    this.options = options;

    if (options.items && options.items.length && options.el) {
      this.renderItems(options.el, options, () => {
        self.initDropdown(options, () => {
          self.listenToClick();
        });
      });
    } else {
      self.initDropdown(options, () => {
        self.listenToClick();
      });
    }
  }
  initDropdown(options, callback) {
    const $el = options && options.el ? options.el : undefined;
    let dropDownEl;
    if ($el) {
      if ($el instanceof Element) {
        if ($el.classList.contains('js-dropdown')) {
          dropDownEl = $el;
        } else {
          dropDownEl = $el.querySelector('.js-dropdown');
        }
      } else if (document.querySelector(".js-dropdown.".concat($el))) {
        dropDownEl = document.querySelector(".js-dropdown.".concat($el));
      } else {
        dropDownEl = document.querySelector(".".concat($el)).querySelector(".js-dropdown");
      }
      const dropdown = dropDownEl;

      this.options = {
        clickCallback: options && options.clickCallback ? options.clickCallback : false,
        dropdownArrow: dropdown.querySelector('.js-dropdown-arrow'),
        dropdownEl: dropdown,
        dropdownSelectedContent: dropdown.querySelector('.js-dropdown-selected-content'),
        dropdownSelectedNode: dropdown.querySelector('.js-dropdown-selected'),
        hasKeyListerners: false,
        list: dropdown.querySelector('.dropdown-list'),
        listContainer: dropdown.querySelector('.dropdown-list-container'),
        listItems: dropdown.querySelectorAll('.dropdown-list-item')
      };
      callback();
    } else {
      this.log.error('No el found in options object.');
    }
  }
  renderItems($el, options, callback) {
    if (options.el && options.items && options.items.length > 0) {
      const items = [];
      for (let i = 0; i < options.items.length; i++) {
        options.items[i].itemIndex = i;
        items.push(svs.ui.dropdown.partials.dropdown_item(options.items[i]));
      }
      const dropdown = svs.ui.dropdown.partials.dropdown({
        bank: options.bank,
        brand: options.brand,
        branding: options.branding,
        disabled: options.disabled,
        class: options.class,
        data: options.data,
        icon: options.icon,
        v2: options.v2,
        itemIndex: options.itemIndex,
        items,
        label: options.label,
        rightLabel: options.rightLabel,
        selectLabel: options.selectLabel
      });
      if ($el instanceof Element) {
        $el.innerHTML = dropdown;
      } else {
        document.querySelector(".".concat($el)).innerHTML = dropdown;
      }
      callback();
    }
  }

  findClickedEl(el, className) {
    do {
      if (el.classList.contains(className)) {
        return el;
      }
      el = el.parentElement;
    } while (el !== null);
  }

  listenToClick() {
    const self = this;
    self.options.dropdownSelectedNode.addEventListener('click', () => {
      if (self.options.dropdownEl.getAttribute('aria-disabled') === 'false') {
        self.options.list.classList.toggle('dropdown-open');
        self.options.dropdownEl.classList.toggle('dropdown-opened');
        self.options.dropdownArrow.classList.toggle('expanded');
        self.options.listContainer.setAttribute('aria-expanded', self.options.list.classList.contains('dropdown-open'));
        self.options.dropdownSelectedNode.setAttribute('aria-expanded', self.options.list.classList.contains('dropdown-open'));
      }
    });
    self.options.list.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const targetEl = self.findClickedEl(e.target, 'js-dropdown-list-item');
      if (targetEl) {
        self.setSelectedListItem(targetEl);
        self.options.dropdownSelectedNode.focus();
      }
    });
    self.options.dropdownEl.querySelector('.js-dropdown-selected').addEventListener('focus', e => {
      if (!self.options.hasKeyListerners) {
        self.listenToKeyboard(e);
      }
    });
  }

  getItemAttributes(element) {
    const item = {};
    const attributes = element.attributes;
    for (let i = 0; i < attributes.length; i++) {
      item[attributes[i].name] = attributes[i].value;
    }
    return item;
  }
  setSelectedListItem(element, e) {
    if (!element.classList.contains('dropdown-item-disabled')) {
      const self = this;
      const dataset = element.dataset;
      const OldDataAttrKeys = Object.keys(self.options.dropdownSelectedNode.dataset);
      const dataAttrKeys = Object.keys(dataset);
      const elToAppend = element.querySelector('.dropdown-header').innerHTML;
      self.options.dropdownSelectedContent.innerHTML = null;
      self.options.dropdownSelectedContent.innerHTML = elToAppend;
      for (let i = 0; i < OldDataAttrKeys.length; i++) {
        self.options.dropdownSelectedNode.removeAttribute("data-".concat(OldDataAttrKeys[i]));
      }
      for (let i = 0; i < dataAttrKeys.length; i++) {
        this.options.dropdownEl.querySelector('.js-dropdown-selected').setAttribute("data-".concat(dataAttrKeys[i]), dataset[dataAttrKeys[i]]);
      }

      for (let i = 0; i < self.options.list.querySelectorAll('.dropdown-item-selected').length; i++) {
        self.options.list.querySelectorAll('.dropdown-item-selected')[i].classList.remove('dropdown-item-selected');
      }
      element.classList.add('dropdown-item-selected');
      self.options.dropdownSelectedNode = self.options.dropdownEl.querySelector('.js-dropdown-selected');
      if (self.options.clickCallback) {
        self.options.clickCallback(self.getItemAttributes(element), e);
      }
      self.closeList();
    }
  }
  closeList() {
    const self = this;
    self.options.list.classList.remove('dropdown-open');
    self.options.dropdownEl.classList.remove('dropdown-opened');
    self.options.dropdownArrow.classList.remove('expanded');
    self.options.listContainer.setAttribute('aria-expanded', false);
    self.options.dropdownSelectedNode.setAttribute('aria-expanded', false);
    self.options.dropdownEl.querySelector('.js-dropdown-selected').focus();
  }

  listenToKeyboard() {
    const self = this;
    const SPACEBAR_KEY_CODE = 32;
    const DOWN_ARROW_KEY_CODE = 40;
    const UP_ARROW_KEY_CODE = 38;
    const ESCAPE_KEY_CODE = 27;
    self.options.hasKeyListerners = true;
    self.options.dropdownSelectedNode.addEventListener('keydown', e => toggleListVisibility(e), true);

    window.addEventListener('keydown', e => {
      if ((e.keyCode === 32 || e.keyCode === DOWN_ARROW_KEY_CODE || e.keyCode === UP_ARROW_KEY_CODE) && e.target.classList.contains('dropdown-selected') || e.target.classList.contains('dropdown-list-item')) {
        e.preventDefault();
      }
    }, true);
    self.options.list.addEventListener('keydown', e => {
      e.preventDefault();
      e.stopPropagation();
      const targetEl = self.findClickedEl(e.target, 'js-dropdown-list-item');
      switch (e.keyCode) {
        case SPACEBAR_KEY_CODE:
          self.setSelectedListItem(targetEl);
          self.options.dropdownSelectedNode.focus();
          return;
        case DOWN_ARROW_KEY_CODE:
          focusNextListItem(DOWN_ARROW_KEY_CODE, targetEl);
          return;
        case UP_ARROW_KEY_CODE:
          focusNextListItem(UP_ARROW_KEY_CODE, targetEl);
          return;
        case ESCAPE_KEY_CODE:
          self.closeList();
          break;
        default:
      }
    });
    function toggleListVisibility(e) {
      if (self.options.dropdownEl.getAttribute('aria-disabled') === 'false') {
        let openDropDown = SPACEBAR_KEY_CODE === e.keyCode;
        if (e.keyCode === ESCAPE_KEY_CODE) {
          self.closeList();
        }
        if (DOWN_ARROW_KEY_CODE === e.keyCode && !self.options.list.classList.contains('dropdown-open')) {
          openDropDown = true;
        }
        if (e.type === 'click' || openDropDown) {
          self.options.list.classList.toggle('dropdown-open');
          self.options.dropdownEl.classList.toggle('dropdown-opened');
          self.options.dropdownArrow.classList.toggle('expanded');
          self.options.listContainer.setAttribute('aria-expanded', self.options.list.classList.contains('dropdown-open'));
          self.options.dropdownSelectedNode.setAttribute('aria-expanded', self.options.list.classList.contains('dropdown-open'));
        }
        if (e.keyCode === DOWN_ARROW_KEY_CODE) {
          e.preventDefault();
          focusNextListItem(DOWN_ARROW_KEY_CODE, e);
        }
        if (e.keyCode === UP_ARROW_KEY_CODE) {
          focusNextListItem(UP_ARROW_KEY_CODE, e);
        }
      }
    }
    function focusNextListItem(direction, element) {
      if (direction === DOWN_ARROW_KEY_CODE) {
        if (!element.classList && element.target.classList.contains('js-dropdown-selected')) {
          self.options.listItems[0].focus();
        } else if (element.nextElementSibling) {
          element.nextElementSibling.focus();
        }
      } else if (direction === UP_ARROW_KEY_CODE) {
        if (element.previousElementSibling) {
          element.previousElementSibling.focus();
        } else {
          self.closeList();
        }
      }
    }
  }
};

 })(window);